import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart } from 'lucide-react';
import StarryBackground from './StarryBackground';

const Footer: React.FC = () => {
  const location = useLocation();

  const handlePricingClick = () => {
    if (location.pathname !== '/') {
      window.location.href = '/#plan-pricing';
    } else {
      document.getElementById('plan-pricing')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-gray-950 overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-80">
        <StarryBackground placement="absolute" density="normal" animated />
      </div>
      <div className="relative mx-auto flex max-w-7xl flex-col gap-8 px-4 pt-16 pb-12 sm:px-6 lg:px-8 text-sm text-gray-200">
        <div className="relative z-10 flex flex-wrap justify-center gap-x-8 gap-y-3">
          <button
            type="button"
            onClick={handlePricingClick}
            className="rounded-full border border-white/15 px-4 py-2 text-gray-200 transition-colors duration-200 hover:border-secondary hover:text-secondary"
          >
            Pricing
          </button>
          <Link
            to="/terms"
            className="rounded-full border border-white/15 px-4 py-2 text-gray-200 transition-colors duration-200 hover:border-secondary hover:text-secondary"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            className="rounded-full border border-white/15 px-4 py-2 text-gray-200 transition-colors duration-200 hover:border-secondary hover:text-secondary"
          >
            Privacy
          </Link>
        </div>

        <div className="relative z-10 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

        <div className="relative z-10 flex flex-col items-center gap-4 text-xs text-gray-400 md:flex-row md:justify-between">
          <div className="flex items-center gap-2">
            <img src="/images/logo.png" alt="LeadLaunch" className="h-6 w-6" />
            <span>© {new Date().getFullYear()} Lead Launch LLC. All rights reserved.</span>
          </div>
          <p className="flex items-center gap-1">
            <span>Made with</span>
            <Heart size={12} className="text-secondary" />
            <span>for paint stores across America</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
